import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
  PHONE_MEDIA_QUERY,
  useMediaQuery,
} from '../../../../common/responsive';
import WidthContainer from '../../../WidthContainer';
import {
  BodyLarge,
  Heading1Text,
  TitleLarge,
  TitleMedium,
} from '../../../Texts';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 90px;
  padding-bottom: 90px;
  gap: 30px;
`;

const ColorizedSpan = styled.span`
  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.text.title} 0%,
    ${({ theme }) => theme.special.purple} 30%,
    ${({ theme }) => theme.primary.primary} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
  width: 100%;
  @media ${PHONE_MEDIA_QUERY} {
    grid-template-columns: repeat(auto-fill, minmax(90%, 1fr));
  }
`;

// Grid item (card) styling
const GridItem = styled.div`
  width: 100%;
  height: 200px;
  background-color: ${({ theme }) => theme.background.primary};
  border: 1px solid ${({ theme }) => theme.border.primary};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 10px;
  padding: 60px 20px;
  transition: transform 0.3s ease;
  cursor: pointer;
  @media (hover: hover) {
    &:hover {
      transform: translateY(-5px);
    }
  }
  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
  }
`;

const ContainerBackground = styled.div`
  background: linear-gradient(
    180deg,
    rgba(236, 245, 255, 0) 0%,
    rgba(236, 245, 255, 1) 100%
  );
  position: absolute;
  width: 100%;
  left: 0px;
`;

const StyledTitleLarge = styled(TitleLarge)`
  font-weight: 600;
`;

const WhyBecomeAPartner = () => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  const backgroundRef = useRef(null);
  const [siblingHeight, setSiblingHeight] = useState<number>(0);

  useEffect(() => {
    const updateHeight = () => {
      const node = backgroundRef.current as HTMLElement | null;
      if (node) {
        setSiblingHeight(node.offsetHeight);
      }
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);

    if (backgroundRef.current) {
      observer.observe(backgroundRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <ContainerBackground ref={backgroundRef}>
        <WidthContainer>
          <Container>
            <Heading1Text style={isMobile ? { textAlign: 'center' } : {}}>
              Why become a <ColorizedSpan>Referral Partner?</ColorizedSpan>
            </Heading1Text>
            <GridContainer>
              <GridItem>
                <StyledTitleLarge>24h go-live</StyledTitleLarge>
                <BodyLarge>Start selling before your next AMA.</BodyLarge>
              </GridItem>
              <GridItem>
                <StyledTitleLarge>Instant mainstream reach</StyledTitleLarge>
                <BodyLarge>
                  Fiat checkout converts non-crypto fans into holders
                </BodyLarge>
              </GridItem>
              <GridItem>
                <StyledTitleLarge>
                  Digital & physical gift cards
                </StyledTitleLarge>
                <BodyLarge>
                  Viral distribution via SMS, e-mail or merch.
                </BodyLarge>
              </GridItem>
              <GridItem>
                <StyledTitleLarge>Passive revenue share</StyledTitleLarge>
                <BodyLarge>
                  Earn up to 50% of revenue made by your token.
                </BodyLarge>
              </GridItem>
              <GridItem>
                <StyledTitleLarge>Self-custody from day one</StyledTitleLarge>
                <BodyLarge>
                  Zero support tickets about “lost wallets”.
                </BodyLarge>
              </GridItem>
              <GridItem>
                <StyledTitleLarge>Dedicated engineer</StyledTitleLarge>
                <BodyLarge>A named DEKS dev for the entire sprint.</BodyLarge>
              </GridItem>
            </GridContainer>
          </Container>
        </WidthContainer>
      </ContainerBackground>
      <div style={{ height: siblingHeight }} />
    </>
  );
};

export default WhyBecomeAPartner;
